(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/non-corporate.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/non-corporate.js');
"use strict";

const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  useEffect,
  useState,
  useContext
} = React;
const {
  Button
} = svs.ui;
const {
  isCorporateSite
} = svs.grassroots.shared.data;
const NonCorporate = _ref => {
  let {
    receiver
  } = _ref;
  const {
    id,
    longname
  } = receiver;
  const {
    selectedReceivers: {
      selectedReceivers,
      setSelectedReceivers
    }
  } = useContext(svs.grassroots.context.Context);
  const [setReceiverSelection, setReceiverResult] = grassrootsQueryApi.useSetReceiverSelectionMutation();
  const [removeReceiverSelection, removeReceiverResult] = grassrootsQueryApi.useRemoveReceiverSelectionMutation();
  const [replaceReceiverSelection, replaceReceiverResult] = grassrootsQueryApi.useReplaceReceiverSelectionMutation();
  const [supportBtn, setSupportBtn] = useState(true);
  const [cancelBtn, setCancelBtn] = useState(false);
  const [replaceBtn, setReplaceBtn] = useState(false);
  const sendAnalytics = (action, receiverName) => {
    const evt = {
      category: 'Gräsroten',
      action,
      opt_label: receiverName
    };
    svs.components.analytics.trackEvent(evt);
  };
  const openErrorDialog = () => {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.grassroots.tenant,
      type: 'error',
      title: 'Ett fel har uppstått',
      message: [{
        text: 'Var vänlig försök igen senare'
      }],
      actions: [{
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  useEffect(() => {
    if (selectedReceivers !== null && selectedReceivers !== void 0 && selectedReceivers.some(receiver => receiver.id === id)) {
      setCancelBtn(true);
      setSupportBtn(false);
      setReplaceBtn(false);
    } else if (!isCorporateSite && (selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.length) < 3) {
      setCancelBtn(false);
      setSupportBtn(true);
      setReplaceBtn(false);
    } else if (!isCorporateSite && (selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.length) === 3) {
      setCancelBtn(false);
      setSupportBtn(false);
      setReplaceBtn(true);
    }
  }, [selectedReceivers]);
  const onCancelSubmit = () => {
    removeReceiverSelection(id);
    sendAnalytics('Avsluta mitt stöd', longname);
  };
  const onSupportSubmit = () => {
    if (!svs.grassroots.shared.data.isCorporateSite && svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      setReceiverSelection(id);

      sendAnalytics('Ge mitt stöd', longname);
    } else {
      svs.components.customer_login.login();
    }
  };
  const onReplaceSubmit = (addId, removeId) => {
    replaceReceiverSelection({
      receiverToAdd: addId,
      receiverToRemove: removeId
    });

    sendAnalytics('Ge mitt stöd', longname);
  };

  useEffect(() => {
    if (removeReceiverResult.isSuccess) {
      var _removeReceiverResult;
      setCancelBtn(false);
      setSupportBtn(true);
      setSelectedReceivers(removeReceiverResult === null || removeReceiverResult === void 0 || (_removeReceiverResult = removeReceiverResult.data) === null || _removeReceiverResult === void 0 ? void 0 : _removeReceiverResult.receivers);
    } else if (removeReceiverResult.isError) {
      openErrorDialog();
    }
  }, [removeReceiverResult.isLoading]);

  useEffect(() => {
    if (setReceiverResult.isSuccess) {
      var _setReceiverResult$da;
      setCancelBtn(true);
      setSupportBtn(false);
      setSelectedReceivers(setReceiverResult === null || setReceiverResult === void 0 || (_setReceiverResult$da = setReceiverResult.data) === null || _setReceiverResult$da === void 0 ? void 0 : _setReceiverResult$da.receivers);
    } else if (setReceiverResult.isError) {
      openErrorDialog();
    }
  }, [setReceiverResult.isLoading]);

  useEffect(() => {
    if (replaceReceiverResult.isSuccess) {
      var _replaceReceiverResul;
      setCancelBtn(true);
      setSupportBtn(false);
      setReplaceBtn(false);
      setSelectedReceivers(replaceReceiverResult === null || replaceReceiverResult === void 0 || (_replaceReceiverResul = replaceReceiverResult.data) === null || _replaceReceiverResul === void 0 ? void 0 : _replaceReceiverResul.receivers);
    } else if (replaceReceiverResult.isError) {
      openErrorDialog();
    }
  }, [replaceReceiverResult.isLoading]);
  return React.createElement("div", {
    className: "margin-top-2"
  }, cancelBtn && React.createElement(Button, {
    block: true,
    className: "grassroots-remove-button",
    disabled: removeReceiverResult === null || removeReceiverResult === void 0 ? void 0 : removeReceiverResult.isLoading,
    inverted: true,
    onClick: onCancelSubmit
  }, "Avsluta mitt st\xF6d"), replaceBtn && React.createElement("div", null, React.createElement("p", null, "Du har valt max antal f\xF6reningar (3st). F\xF6r att v\xE4lja", ' ', longname, ' ', "m\xE5ste du ers\xE4tta n\xE5gon f\xF6rening nedan."), selectedReceivers === null || selectedReceivers === void 0 ? void 0 : selectedReceivers.map(receiver => React.createElement(Button, {
    block: true,
    className: "margin-top-1 grassroots-replace-button",
    disabled: replaceReceiverResult === null || replaceReceiverResult === void 0 ? void 0 : replaceReceiverResult.isLoading,
    inverted: true,
    key: receiver.id,
    onClick: () => onReplaceSubmit(id, receiver.id)
  }, "Ers\xE4tt", ' ', receiver === null || receiver === void 0 ? void 0 : receiver.longname))), supportBtn && React.createElement(Button, {
    block: true,
    className: "grassroots-add-button",
    disabled: setReceiverResult === null || setReceiverResult === void 0 ? void 0 : setReceiverResult.isLoading,
    inverted: true,
    onClick: onSupportSubmit
  }, "Ge mitt st\xF6d"));
};
svs.grassroots.components.receiver.non_corporate = NonCorporate;

 })(window);